import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=6603a2fe&"
import script from "./OfficeDetail.vue?vue&type=script&lang=ts&"
export * from "./OfficeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports